import React from "react";
import { PropTypes } from "prop-types";

import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
} from "@material-ui/icons";

const OHSPLCOrgChartButton = ({ children, directSubordinates }) => {
  const style = {
    color: "#fff",
    borderRadius: "10px",
    padding: "1px 2px 1px 1px",
    fontSize: "8px",
    margin: "auto",
    backgroundColor: "white",
    border: "1.5px solid #203a75",
    display: "flex",
    alignItems: "center",
    placeContent: "center",
    justifyContent: "center",
  };

  const number = {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    paddingLeft: "0.25rem",
    color: "rgb(203 34 123)",
    justifyContent: "center",
    alignItems: "center",
  };

  const arrow = {
    width: "0.5rem",
    height: "0.5rem",
    fontSize: "1rem",
    lineHeight: "1rem",
    color: "rgb(32 58 117)",
    paddingBottom: "1px",
  };

  const buttonDiv = {
    display: "flex",
    width: "100%",
    height: "85%",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <div style={buttonDiv}>
      <div className="flex items-center place-content-center" style={style}>
        <span className="font-bold text-secondary" style={number}>
          {directSubordinates}
        </span>
        {children ? (
          <ArrowBackIosRounded className="text-primary" style={arrow} />
        ) : (
          <ArrowForwardIosRounded className="text-primary" style={arrow} />
        )}
      </div>
    </div>
  );
};

OHSPLCOrgChartButton.propTypes = {
  directSubordinates: PropTypes.number,
  children: PropTypes.array,
};

export default OHSPLCOrgChartButton;
